export const dashInvoices = {
  invoices: {
    title: "Factures à envoyer",
    subtitle: "Vous verrez ici les demandes en attente d'émission de facture.",
    loading: "Chargement…",
    empty: "Aucune facture à envoyer.",
    guestFallback: "Client",
    manualBadge: "Manuel",
    manualBadgeTitle: "Non générée automatiquement : vous l'émettez manuellement",
    manualCheckoutTitle: "Non générée automatiquement : émettez-la manuellement",
    linkSentTitle: "Lien envoyé au client",
    linkPendingTitle: "Le lien sera envoyé le jour du check-out",
    manualIssue: "Émission manuelle",
    sendLinkTitle: "Envoyez au client le lien pour compléter ses informations de facturation",
    resend: "Renvoyer",
    sendLink: "Envoyer le lien",
    closeRequestTitle: "Fermer cette demande (vous l'émettez manuellement)",
    close: "Fermer",
    cancelAutoTitle: "Annuler l'envoi automatique pour l'envoyer manuellement par un autre moyen",
    cancel: "Annuler",
    viewAll: "Voir toutes les factures",
    confirmCancel: {
      title: "Annuler l'envoi automatique ?",
      html: "Le lien de la facture ne sera pas envoyé au client.<br>Vous pourrez l'envoyer manuellement par un autre moyen.",
      confirm: "Oui, annuler",
      cancel: "Non",
    },
    confirmSend: {
      title: "Envoyer le lien de la facture ?",
      html: "Le lien pour compléter ses informations fiscales sera envoyé au client via WhatsApp.<br>Vous émettez la facture manuellement.",
      confirm: "Oui, envoyer",
      cancel: "Non",
    },
    cancelError: {
      title: "Annulation impossible",
    },
    closeError: {
      title: "Fermeture impossible",
    },
    sendError: {
      title: "Envoi impossible",
    },
    sendSuccess: {
      title: "Lien envoyé",
      text: "Le client a reçu le lien de la facture.",
    },
    retry: "Veuillez réessayer.",
  },
  balances: {
    title: "Soldes en attente",
    subtitle: "Réservations avec un montant dû.",
    total: "Total",
    paid: "Paiement traité",
    loading: "Chargement…",
    empty: "Aucun solde en attente.",
    emptySub: "Lorsqu'une réservation a un montant dû, elle apparaîtra ici.",
    viewAll: "Voir tous les soldes",
  },
  balancesDrawer: {
    title: "Soldes en attente",
    close: "Fermer",
    from: "Du",
    to: "Au",
    sort: "Trier",
    sortArrival: "Date de check-in",
    sortProximity: "Proximité de l'arrivée",
    searchPlaceholder: "Rechercher un hébergement…",
    allAccommodations: "Tous les hébergements",
    noResults: "Aucun résultat",
    clear: "Effacer",
    totalPending: "Total en attente",
    ofTotal: "sur {amount} {currency}",
    loading: "Chargement…",
    empty: "Aucune réservation avec un solde en attente.",
    end: "Plus rien.",
    tags: {
      ended: "Séjour terminé",
      now: "Sur place",
      today: "Arrive aujourd'hui",
      tomorrow: "Arrive demain",
      dayAfter: "Arrive dans 2 jours",
    },
  },
};
